import crudHandlers from './_crud'

export default (state, action) => {
	const { type } = action
	switch (type) {
		case 'LOAD_STATIONS':
			return {
				...state,
				entities: action.payload,
			}

		default:
			state = crudHandlers(state, action, 'station')

			return state
	}
}
